import React from 'react';
import './Terms.css'; // Reuse the same styles

const Privacy = () => (
  <div className="legalWrapper">
    <h1>Privacy Policy</h1>
    <p><strong>Last Updated:</strong> June 8th, 2025</p>

    <h2>New ‘U’ Physical Therapy</h2>
    <p>
      ("we", "us", or "our") is committed to protecting your privacy. This policy explains how we collect, use, and protect your information.
    </p>

    <h2>Information We Collect</h2>
    <p>
      We collect personal information such as name, email address, phone number, and insurance information.
    </p>

    <h2>How We Use Your Information</h2>
    <p>
      We use your data to better help you and ourselves understand the best way to treat you, improve the website experience, and — with your consent — send you updates, promotions, and authorization reminders.
    </p>

    <h2>Sharing Your Information</h2>
    <p>
      We do not share your data with any third-party services. All data is used only within our services. However we do contain some links to third party services that we are not invloveld. Please read their privacy to better understand what they require. 
    </p>

    <h2>Your Rights</h2>
    <p>
      You can request to access, update, or delete your personal information. Contact us at <a href="mailto:newupt@yahoo.com">newupt@yahoo.com</a>.
    </p>

    <h2>Cookies</h2>
    <p>
      We use cookies to track website performance and enhance your experience. You can disable cookies in your browser settings; however, some website features may not work properly if disabled.
    </p>

    <h2>Security</h2>
    <p>
      We take reasonable steps to protect your information, but no method is 100% secure.
    </p>

       <h2>Consent</h2>
    <p>
      By providing you email and phone number will be able to consent to receive email and text messages. To stop receiving messages you can change it in your dashboard.
    </p>


    <h2>Changes to This Policy</h2>
    <p>
      We may update this policy. The latest version will always be on this page. With your consent, a notification will be sent if there are any changes.
    </p>

    <h2>Questions?</h2>
    <p>
      Contact us at <a href="mailto:newupt@yahoo.com">newupt@yahoo.com</a>.
    </p>
  </div>
);

export default Privacy;
